import { PATTERNS } from './patterns';

export const isUUID = (value) => PATTERNS.UUID.test(value);
export const isBooleanFlag = (value) => value === 'true';
